export default __webpack_public_path__ + "static/media/logo.f1baee17.png";